import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import BannerForm from "../../../components/forms/admin/BannerForm";
import BannersList from "../../../components/lists/Banners";
import ChangeEditLang from "../../../components/util/ChangeEditLang";
import { Button, Link } from "../../../components/util/Clickable";
import { get } from "../../../actions/banner";
import { add } from "../../../actions/admin/banner";
import { Notification } from "../../../utils/notification";

declare var UIkit;

class IndexScreen extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      banners: {"in_session": [], "before_held": [], "post_event": []},
      meta: {
        current_page: 0,
        last_page: null,
      },
      loading: false,
    };
  }

  componentWillMount = () => {
    this.readMore(true);
  };

  readMore = (refresh = false) => {
    if (!refresh) {
      this.setState({ loading: true });
    }
    this.props.actions
      .get({
        page: this.state.meta.current_page + 1,
      })
      .then(({ value, action }) => {
        if (value.status < 300) {
          this.setState({
            banners:
              this.state.banners && !refresh
                ? this.state.banners.concat(value.data)
                : value.data,
            meta: value.response.data.meta,
            loading: false,
          });
        }
      })
      .catch((error) => console.log(error));
  };

  onAdded = (values) => {
    UIkit.modal(this.addModal).hide();
    this.addForm.wrappedInstance.props.reset();
    this.setState(
      {
        news: [values].concat(this.state.news),
      },
      () => {
        Notification.success("Add succeeded.");
      },
    );
  };

  render = () => {
    return (
      <div>
        <div className="uk-margin-small" data-uk-grid>
          <div className="uk-width-auto">
            <h1>Banners</h1>
          </div>
          <div className="uk-width-expand">
            <Link
              className="uk-button uk-button-default"
              onClick={() => {
                UIkit.modal(this.addModal, { container: false }).show();
              }}
            >
              <span>Add</span>
              <span
                className="uk-margin-small-left"
                data-uk-icon="icon:plus; ratio:0.8;"
              />
            </Link>
          </div>
          <div className="uk-width-medium@s uk-width-1-1 uk-text-right">
            <ChangeEditLang />
          </div>
        </div>

        <div className="uk-margin-large">
          <h1>In session</h1>
          <BannersList
            lang={this.props.language.edit}
            banners={this.state.banners.session_banner?.data}
          />
        </div>
        <div className="uk-margin-large">
          <h1>Before held</h1>
          <BannersList
            lang={this.props.language.edit}
            banners={this.state.banners.before_banner?.data}
          />
        </div>
        <div className="uk-margin-large">
          <h1>Post event</h1>
          <BannersList
            lang={this.props.language.edit}
            banners={this.state.banners.after_banner?.data}
          />
        </div>

        <div ref={(addModal) => (this.addModal = addModal)} data-uk-modal>
          <div className="uk-modal-dialog uk-width-xxlarge@s">
            <button
              className="uk-modal-close-default"
              type="button"
              data-uk-close
            ></button>
            <div className="uk-modal-header">
              <h2 className="uk-modal-title">Add Banner</h2>
            </div>
            <div className="uk-modal-body">
              <BannerForm
                ref={(addForm) => (this.addForm = addForm)}
                form="banner-add-form"
                onSubmit={(values) => this.props.actions.add(values)}
                onSuccess={this.onAdded}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    language: state.language,
    admin: state.auth.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      get: (...param) => dispatch(get(...param)),
      add: (...param) => dispatch(add(...param)),
    },
    dispatch,
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(IndexScreen),
);
